import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vShow as _vShow, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "header-flex" }
const _hoisted_3 = { class: "subtitulo" }
const _hoisted_4 = { class: "controles" }
const _hoisted_5 = { class: "control" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "control" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  class: "control"
}
const _hoisted_11 = {
  key: 1,
  class: "control control-btn"
}
const _hoisted_12 = {
  key: 0,
  class: "ayuda-escala"
}
const _hoisted_13 = {
  key: 1,
  class: "aviso"
}
const _hoisted_14 = {
  key: 2,
  class: "info"
}
const _hoisted_15 = {
  key: 3,
  class: "aviso aviso-error"
}
const _hoisted_16 = { class: "barra-superior" }
const _hoisted_17 = { class: "periodos-bar" }
const _hoisted_18 = { class: "badge badge-actual" }
const _hoisted_19 = { class: "badge badge-anterior" }
const _hoisted_20 = { class: "acciones-derecha" }
const _hoisted_21 = { class: "vista-tabs" }
const _hoisted_22 = {
  key: 0,
  class: "ayuda-emparejar"
}
const _hoisted_23 = { class: "contenedor-tabla" }
const _hoisted_24 = { class: "lista-tabla comparativo" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "col-num" }
const _hoisted_27 = { class: "col-num" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "col-nombre" }
const _hoisted_30 = {
  key: 0,
  class: "ordinal"
}
const _hoisted_31 = {
  key: 1,
  class: "drill-hint"
}
const _hoisted_32 = ["disabled", "value", "onChange"]
const _hoisted_33 = ["value"]
const _hoisted_34 = {
  key: 1,
  class: "vacio"
}
const _hoisted_35 = { class: "col-num" }
const _hoisted_36 = {
  key: 0,
  class: "databar-wrap"
}
const _hoisted_37 = { class: "databar-val" }
const _hoisted_38 = {
  key: 1,
  class: "vacio"
}
const _hoisted_39 = { class: "col-num" }
const _hoisted_40 = { class: "col-num" }
const _hoisted_41 = {
  key: 0,
  class: "databar-wrap"
}
const _hoisted_42 = { class: "databar-val" }
const _hoisted_43 = {
  key: 1,
  class: "vacio"
}
const _hoisted_44 = {
  key: 1,
  class: "sin-equiv",
  title: "Sin equivalente en el periodo anterior (empareja manualmente)"
}
const _hoisted_45 = { class: "col-num" }
const _hoisted_46 = { class: "col-num" }
const _hoisted_47 = {
  key: 1,
  class: "vacio"
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = ["colspan"]
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "fila-global" }
const _hoisted_52 = { class: "col-nombre" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = {
  key: 1,
  class: "vacio"
}
const _hoisted_55 = { class: "col-num" }
const _hoisted_56 = { class: "col-num" }
const _hoisted_57 = { class: "col-num" }
const _hoisted_58 = { class: "col-num" }
const _hoisted_59 = { class: "col-num" }
const _hoisted_60 = {
  key: 1,
  class: "vacio"
}
const _hoisted_61 = { class: "grafico-comp" }
const _hoisted_62 = { class: "leyenda" }
const _hoisted_63 = { class: "leyenda-item" }
const _hoisted_64 = { class: "leyenda-item" }
const _hoisted_65 = { class: "grafico-nivel" }
const _hoisted_66 = {
  key: 0,
  class: "mensaje-vacio"
}
const _hoisted_67 = {
  key: 1,
  class: "contenedor-tabla"
}
const _hoisted_68 = ["viewBox"]
const _hoisted_69 = ["x2"]
const _hoisted_70 = ["y1", "y2"]
const _hoisted_71 = ["y1", "x2", "y2"]
const _hoisted_72 = ["y"]
const _hoisted_73 = ["x", "y", "height"]
const _hoisted_74 = ["x", "y"]
const _hoisted_75 = ["x", "y", "height"]
const _hoisted_76 = ["x", "y"]
const _hoisted_77 = ["x"]
const _hoisted_78 = { class: "fuente" }

import { ref, computed, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useGestionComparacion } from '@/store/GestionComparacion'
import { useGestionProcesos } from '@/store/GestionProcesoAutoevaluacion'
import { getProcesoByIdService } from '@/services/ProcesoAutoevaluacionService'
import {
  emparejarComponentesService,
  desemparejarComponenteService,
  getComponentesVersionService,
  type ComponentePlano
} from '@/services/ComparacionService'
import type { Proceso } from '@/interfaces/ProcesoAutoevaluacion'
import type { FilaComparacion } from '@/interfaces/ComparacionCalificacion'
import MensajeFlotante from '@/components/MensajeFlotante.vue'

const anchoBarra = 20
const pasoGrupo = 62

export default /*@__PURE__*/_defineComponent({
  __name: 'ComparacionCalificacionesView',
  setup(__props) {

/**
 * Comparativo entre periodos.
 *
 * Requiere un esquema de correspondencias declarado a mano: los componentes sin
 * equivalencia no aparecen en el comparativo.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/ejecucion/:id_ejecucion/comparacion` (ComparacionCalificaciones) — permiso `calificacion.ver`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const route = useRoute()
const idEjecucion = Number(route.params.id_ejecucion)

const comparStore = useGestionComparacion()
const procesosStore = useGestionProcesos()

const procesoActual = ref<Proceso | null>(null)
const anteriorSel = ref<number | null>(null)
const factorSel = ref<number | null>(null)
const factores = ref<{ id: number; nombre: string; ordinal: string | null }[]>([])
const listo = ref(false)

const vista = ref<'tabla' | 'grafico'>('tabla')
const modoEmparejar = ref(false)
const componentesAnteriores = ref<ComponentePlano[]>([])
const guardandoPareo = ref<number | null>(null)

const msgVisible = ref(false)
const msgTexto = ref('')
const msgTipo = ref<'positivo' | 'error'>('positivo')

const comparacion = computed(() => comparStore.comparacion)

const candidatosAnterior = computed(() => {
  if (!procesoActual.value) return []
  const base = procesoActual.value
  return procesosStore.procesos
    .filter(p =>
      p.id !== idEjecucion &&
      p.ambito === base.ambito &&
      (p.id_programa ?? null) === (base.id_programa ?? null)
    )
    .sort((a, b) => (b.periodo ?? '').localeCompare(a.periodo ?? ''))
})

function toast(texto: string, tipo: 'positivo' | 'error' = 'positivo') {
  msgTexto.value = texto
  msgTipo.value = tipo
  msgVisible.value = true
}

async function cargar(): Promise<void> {
  if (!anteriorSel.value) {
    comparStore.limpiar()
    return
  }
  await comparStore.cargar(idEjecucion, {
    anterior: anteriorSel.value,
    componente: factorSel.value ?? undefined
  })
  if (!factorSel.value && comparStore.comparacion) {
    factores.value = comparStore.comparacion.filas
      .map(f => ({ id: f.id_componente, nombre: f.nombre, ordinal: f.ordinal }))
      .sort((a, b) => cmpOrdinal(a.ordinal, b.ordinal))
  }
  // Componentes del periodo anterior (para el emparejamiento manual).
  const idVersionAnterior = comparStore.comparacion?.anterior?.id_version
  componentesAnteriores.value = idVersionAnterior
    ? (await getComponentesVersionService(idVersionAnterior))
        .filter(c => c.nivel > 1)
        .sort((a, b) => cmpOrdinal(a.ordinal ?? null, b.ordinal ?? null))
    : []
}

function drill(idComponente: number): void {
  factorSel.value = idComponente
}

function toggleEmparejar(): void {
  modoEmparejar.value = !modoEmparejar.value
  if (modoEmparejar.value && !componentesAnteriores.value.length) {
    toast('No se pudo cargar la estructura del periodo anterior.', 'error')
  }
}

async function onCambiarPareo(fila: FilaComparacion, ev: Event): Promise<void> {
  const val = (ev.target as HTMLSelectElement).value
  guardandoPareo.value = fila.id_componente
  const res = val
    ? await emparejarComponentesService(fila.id_componente, Number(val))
    : await desemparejarComponenteService(fila.id_componente)
  guardandoPareo.value = null

  if (res.ok) {
    toast(val ? 'Emparejamiento guardado.' : 'Emparejamiento automático restaurado.')
    await cargar()
  } else {
    toast(res.error ?? 'No se pudo guardar.', 'error')
  }
}

function fmtOrdinal(ordinal: string | null | undefined): string {
  if (!ordinal) return ''
  const parts = ordinal.split('.')
  return parts.length <= 1 ? ordinal : parts.slice(1).join('.')
}

// ── Orden numérico de ordinales ("1.10" va después de "1.2") ─────────────────

function cmpOrdinal(a: string | null | undefined, b: string | null | undefined): number {
  if (!a && !b) return 0
  if (!a) return 1
  if (!b) return -1
  const pa = a.split('.').map(Number)
  const pb = b.split('.').map(Number)
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0)
    if (d !== 0) return d
  }
  return 0
}

// ── Formato / colores ────────────────────────────────────────────────────────

function fmtCalif(v: number | null): string { return v === null ? '—' : v.toFixed(2) }

/**
 * Escala en la que se leen las notas de la tabla.
 *
 * `null` = cada periodo con la suya (como estaba). Al elegir 5 o 10 se muestran
 * las equivalencias que ya calcula el backend: no se convierte aquí, porque una
 * segunda implementación de la fórmula acabaría discrepando de la primera.
 */
const escalaUnificada = ref<5 | 10 | null>(null)

/** Nota de una celda en la escala elegida. */
function notaEn(celda: { calif: number | null; en_cinco?: number | null; en_diez?: number | null } | null): number | null {
  if (!celda) return null
  if (escalaUnificada.value === 5) return celda.en_cinco ?? null
  if (escalaUnificada.value === 10) return celda.en_diez ?? null
  return celda.calif
}

/**
 * Variación a mostrar.
 *
 * Con escala unificada se usa la variación en PUNTOS que trae el backend
 * (calculada con los dos periodos en 0–5); sin unificar, el porcentaje, que es
 * lo único comparable cuando cada periodo va en su escala.
 */
function variacionDe(fila: { variacion: number | null; variacion_nota?: number | null }): number | null {
  return escalaUnificada.value === null ? fila.variacion : (fila.variacion_nota ?? null)
}

/** Texto de la variación: puntos porcentuales sin unificar, puntos de nota con escala unificada. */
function textoVariacion(v: number | null): string {
  if (v === null) return '—'
  const signo = v > 0 ? '+' : ''
  return escalaUnificada.value === null
    ? `${signo}${v.toFixed(1)}`
    : `${signo}${v.toFixed(2)} pts`
}
function fmtPct(v: number | null): string { return v === null ? '—' : `${v.toFixed(1)}%` }
function barWidth(pct: number | null): string { return `${Math.max(0, Math.min(100, pct ?? 0))}%` }

function nivelClase(calif: number | null): string {
  if (calif === null || !comparacion.value) return ''
  const escala = comparacion.value.escala_max || 5
  const norm = escala > 0 ? (calif / escala) * 5 : calif
  if (norm >= 4.5) return 'nivel-excelente'
  if (norm >= 4.0) return 'nivel-alto'
  if (norm >= 3.0) return 'nivel-medio'
  return 'nivel-bajo'
}

function varClase(v: number): string { return v > 0 ? 'var-pos' : v < 0 ? 'var-neg' : 'var-neutra' }
function varFlecha(v: number): string { return v > 0 ? '▲' : v < 0 ? '▼' : '—' }

// ── Gráfico de barras (actual vs anterior) ───────────────────────────────────

const filasOrdenadas = computed(() =>
  [...(comparacion.value?.filas ?? [])].sort((a, b) => cmpOrdinal(a.ordinal, b.ordinal))
)

const barras = computed(() =>
  filasOrdenadas.value.map(f => ({
    id: f.id_componente,
    ordinal: f.ordinal,
    nombre: f.nombre,
    actual: f.actual.calif,
    anterior: f.anterior?.calif ?? null
  }))
)

const anchoSvg = computed(() => Math.max(300, 60 + barras.value.length * pasoGrupo))
function grupoX(i: number): number { return 56 + i * pasoGrupo }

const escalaMax = computed(() => comparacion.value?.escala_max || 5)
const ejeTicks = computed(() => {
  const max = Math.ceil(escalaMax.value)
  const paso = max <= 5 ? 1 : 2
  const ticks: number[] = []
  for (let t = 0; t <= max; t += paso) ticks.push(t)
  return ticks
})
function yPos(v: number): number {
  const max = escalaMax.value || 5
  return 190 - (Math.max(0, Math.min(max, v)) / max) * 178
}

// ── Carga inicial ────────────────────────────────────────────────────────────

watch([anteriorSel, factorSel], () => { if (listo.value) cargar() })

onMounted(async () => {
  const [proceso] = await Promise.all([
    getProcesoByIdService(idEjecucion),
    procesosStore.cargarTodos()
  ])
  procesoActual.value = proceso

  const enlazada = proceso?.id_ejecucion_anterior ?? proceso?.anterior?.id_ejecucion ?? null
  anteriorSel.value = enlazada ?? candidatosAnterior.value[0]?.id ?? null

  listo.value = true
  await cargar()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[9] || (_cache[9] = _createElementVNode("h1", null, "Comparativo de Evaluación", -1)),
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode(" Ejecución #" + _toDisplayString(_unref(idEjecucion)) + " ", 1),
          (comparacion.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" · Escala 0–" + _toDisplayString(comparacion.value.escala_max), 1)
              ], 64))
            : _createCommentVNode("", true),
          (comparacion.value?.factor)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" · " + _toDisplayString(comparacion.value.factor.nombre), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("button", {
        class: "btn salir",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'ProcesoAutoevaluacionUsuario' })))
      }, "Volver")
    ]),
    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "divider" }, null, -1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[11] || (_cache[11] = _createElementVNode("label", null, "Periodo anterior", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((anteriorSel).value = $event)),
          class: "input-select"
        }, [
          _cache[10] || (_cache[10] = _createElementVNode("option", {
            value: null,
            disabled: ""
          }, "Selecciona un periodo", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(candidatosAnterior.value, (c) => {
            return (_openBlock(), _createElementBlock("option", {
              key: c.id,
              value: c.id
            }, _toDisplayString(c.periodo) + " — " + _toDisplayString(c.estado), 9, _hoisted_6))
          }), 128))
        ], 512), [
          [_vModelSelect, anteriorSel.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[13] || (_cache[13] = _createElementVNode("label", null, "Nivel", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((factorSel).value = $event)),
          class: "input-select",
          disabled: !factores.value.length
        }, [
          _cache[12] || (_cache[12] = _createElementVNode("option", { value: null }, "Todos los factores (resumen)", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(factores.value, (f) => {
            return (_openBlock(), _createElementBlock("option", {
              key: f.id,
              value: f.id
            }, _toDisplayString(f.ordinal ? fmtOrdinal(f.ordinal) + ' ' : '') + _toDisplayString(f.nombre), 9, _hoisted_9))
          }), 128))
        ], 8, _hoisted_8), [
          [_vModelSelect, factorSel.value]
        ])
      ]),
      (comparacion.value?.escalas_distintas)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _cache[15] || (_cache[15] = _createElementVNode("label", null, "Escala de lectura", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((escalaUnificada).value = $event)),
              class: "input-select"
            }, _cache[14] || (_cache[14] = [
              _createElementVNode("option", { value: null }, "Cada periodo con la suya", -1),
              _createElementVNode("option", { value: 5 }, "Todo en 0–5", -1),
              _createElementVNode("option", { value: 10 }, "Todo en 1–10", -1)
            ]), 512), [
              [_vModelSelect, escalaUnificada.value]
            ])
          ]))
        : _createCommentVNode("", true),
      (factorSel.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "btn salir btn-sm",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (factorSel.value = null))
            }, "‹ Todos los factores")
          ]))
        : _createCommentVNode("", true)
    ]),
    (comparacion.value?.escalas_distintas && escalaUnificada.value !== null)
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
          _createTextVNode(" Notas convertidas para poder leerlas juntas (" + _toDisplayString(comparacion.value.actual.periodo) + " va en 0–" + _toDisplayString(comparacion.value.escala_max) + " y " + _toDisplayString(comparacion.value.anterior.periodo) + " en 0–" + _toDisplayString(comparacion.value.escala_max_anterior) + "). El ", 1),
          _cache[16] || (_cache[16] = _createElementVNode("strong", null, "grado de cumplimiento no cambia", -1)),
          _cache[17] || (_cache[17] = _createTextVNode(": lo sigue dando la rúbrica del modelo de cada periodo, que es la que firmó ese informe. "))
        ]))
      : _createCommentVNode("", true),
    (!anteriorSel.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, " No hay un periodo anterior de la misma área para comparar. Registra o enlaza otra ejecución. "))
      : (_unref(comparStore).cargando)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Cargando comparación…"))
        : (_unref(comparStore).error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(comparStore).error), 1))
          : (comparacion.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, "Actual: " + _toDisplayString(comparacion.value.actual.periodo), 1),
                    _createElementVNode("span", _hoisted_19, "Anterior: " + _toDisplayString(comparacion.value.anterior.periodo), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["vtab", { activo: vista.value === 'tabla' }]),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (vista.value = 'tabla'))
                      }, "Tabla", 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(["vtab", { activo: vista.value === 'grafico' }]),
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (vista.value = 'grafico'))
                      }, "Gráfico", 2)
                    ]),
                    (vista.value === 'tabla')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass(["btn btn-sm", modoEmparejar.value ? 'emparejar-on' : 'emparejar-off']),
                          onClick: toggleEmparejar
                        }, _toDisplayString(modoEmparejar.value ? '✓ Emparejando' : 'Emparejar manual'), 3))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (modoEmparejar.value && vista.value === 'tabla')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_22, " Elige, por cada componente, con cuál del periodo anterior se compara (útil cuando cambió el nombre). "))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_23, [
                  _createElementVNode("table", _hoisted_24, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(factorSel.value ? 'Característica' : 'Factor'), 1),
                        (modoEmparejar.value)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_25, "Emparejar con (anterior)"))
                          : _createCommentVNode("", true),
                        _cache[18] || (_cache[18] = _createElementVNode("th", null, "Grado de cumplimiento", -1)),
                        _createElementVNode("th", _hoisted_26, "Calif. " + _toDisplayString(comparacion.value.actual.periodo), 1),
                        _cache[19] || (_cache[19] = _createElementVNode("th", { class: "col-num" }, "%", -1)),
                        _createElementVNode("th", _hoisted_27, "Calif. " + _toDisplayString(comparacion.value.anterior.periodo), 1),
                        _cache[20] || (_cache[20] = _createElementVNode("th", { class: "col-num" }, "%", -1)),
                        _cache[21] || (_cache[21] = _createElementVNode("th", { class: "col-num" }, "Variación", -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filasOrdenadas.value, (f) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: f.id_componente,
                          class: _normalizeClass({ clickable: !factorSel.value && !modoEmparejar.value }),
                          onClick: ($event: any) => ((!factorSel.value && !modoEmparejar.value) && drill(f.id_componente))
                        }, [
                          _createElementVNode("td", _hoisted_29, [
                            (f.ordinal)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(fmtOrdinal(f.ordinal)), 1))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(f.nombre) + " ", 1),
                            (!factorSel.value && !modoEmparejar.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_31, "ver características ›"))
                              : _createCommentVNode("", true)
                          ]),
                          (modoEmparejar.value)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 0,
                                class: "col-pareo",
                                onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _createElementVNode("select", {
                                  class: "input-select select-pareo",
                                  disabled: guardandoPareo.value === f.id_componente,
                                  value: f.anterior_componente?.id_componente ?? '',
                                  onChange: ($event: any) => (onCambiarPareo(f, $event))
                                }, [
                                  _cache[22] || (_cache[22] = _createElementVNode("option", { value: "" }, "— Automático —", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(componentesAnteriores.value, (c) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: c.id_componente,
                                      value: c.id_componente
                                    }, _toDisplayString((c.ordinal ? fmtOrdinal(c.ordinal) + ' · ' : '') + c.nombre), 9, _hoisted_33))
                                  }), 128))
                                ], 40, _hoisted_32)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", null, [
                            (f.grado)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(["badge-grado", nivelClase(f.actual.calif)])
                                }, _toDisplayString(f.grado), 3))
                              : (_openBlock(), _createElementBlock("span", _hoisted_34, "—"))
                          ]),
                          _createElementVNode("td", _hoisted_35, [
                            (f.actual.calif !== null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["databar", nivelClase(f.actual.calif)]),
                                    style: _normalizeStyle({ width: barWidth(f.actual.pct) })
                                  }, null, 6),
                                  _createElementVNode("span", _hoisted_37, _toDisplayString(fmtCalif(notaEn(f.actual))), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_38, "—"))
                          ]),
                          _createElementVNode("td", _hoisted_39, _toDisplayString(fmtPct(f.actual.pct)), 1),
                          _createElementVNode("td", _hoisted_40, [
                            (f.anterior)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (f.anterior.calif !== null)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                        _createElementVNode("div", {
                                          class: "databar databar-tenue",
                                          style: _normalizeStyle({ width: barWidth(f.anterior.pct) })
                                        }, null, 4),
                                        _createElementVNode("span", _hoisted_42, _toDisplayString(fmtCalif(notaEn(f.anterior))), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_43, "—"))
                                ], 64))
                              : (_openBlock(), _createElementBlock("span", _hoisted_44, "sin equiv."))
                          ]),
                          _createElementVNode("td", _hoisted_45, _toDisplayString(f.anterior ? fmtPct(f.anterior.pct) : '—'), 1),
                          _createElementVNode("td", _hoisted_46, [
                            (variacionDe(f) !== null)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(["variacion", varClase(variacionDe(f))])
                                }, _toDisplayString(varFlecha(variacionDe(f))) + " " + _toDisplayString(textoVariacion(variacionDe(f))), 3))
                              : (_openBlock(), _createElementBlock("span", _hoisted_47, "—"))
                          ])
                        ], 10, _hoisted_28))
                      }), 128)),
                      (!comparacion.value.filas.length)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [
                            _createElementVNode("td", {
                              colspan: modoEmparejar.value ? 8 : 7,
                              class: "mensaje-vacio"
                            }, "No hay datos consolidados para comparar en este nivel.", 8, _hoisted_49)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (comparacion.value.global_factor)
                      ? (_openBlock(), _createElementBlock("tfoot", _hoisted_50, [
                          _createElementVNode("tr", _hoisted_51, [
                            _createElementVNode("td", _hoisted_52, "CALIFICACIÓN GLOBAL " + _toDisplayString(factorSel.value ? 'DEL FACTOR' : 'DEL MODELO'), 1),
                            (modoEmparejar.value)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_53))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", null, [
                              (comparacion.value.global_factor.grado)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(["badge-grado", nivelClase(comparacion.value.global_factor.actual.calif)])
                                  }, _toDisplayString(comparacion.value.global_factor.grado), 3))
                                : (_openBlock(), _createElementBlock("span", _hoisted_54, "—"))
                            ]),
                            _createElementVNode("td", _hoisted_55, _toDisplayString(fmtCalif(notaEn(comparacion.value.global_factor.actual))), 1),
                            _createElementVNode("td", _hoisted_56, _toDisplayString(fmtPct(comparacion.value.global_factor.actual.pct)), 1),
                            _createElementVNode("td", _hoisted_57, _toDisplayString(comparacion.value.global_factor.anterior ? fmtCalif(notaEn(comparacion.value.global_factor.anterior)) : '—'), 1),
                            _createElementVNode("td", _hoisted_58, _toDisplayString(comparacion.value.global_factor.anterior ? fmtPct(comparacion.value.global_factor.anterior.pct) : '—'), 1),
                            _createElementVNode("td", _hoisted_59, [
                              (variacionDe(comparacion.value.global_factor) !== null)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(["variacion", varClase(variacionDe(comparacion.value.global_factor))])
                                  }, _toDisplayString(varFlecha(variacionDe(comparacion.value.global_factor))) + " " + _toDisplayString(textoVariacion(variacionDe(comparacion.value.global_factor))), 3))
                                : (_openBlock(), _createElementBlock("span", _hoisted_60, "—"))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[23] || (_cache[23] = _createElementVNode("p", { class: "fuente" }, "La variación se expresa en puntos porcentuales (% actual − % anterior).", -1))
                ], 512), [
                  [_vShow, vista.value === 'tabla']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("span", _hoisted_63, [
                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "cuadro cuadro-actual" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(comparacion.value.actual.periodo) + " (actual)", 1)
                    ]),
                    _createElementVNode("span", _hoisted_64, [
                      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "cuadro cuadro-anterior" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(comparacion.value.anterior.periodo) + " (anterior)", 1)
                    ]),
                    _createElementVNode("span", _hoisted_65, _toDisplayString(factorSel.value ? 'Por característica' : 'Por factor'), 1)
                  ]),
                  (!barras.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, "No hay datos para graficar."))
                    : (_openBlock(), _createElementBlock("div", _hoisted_67, [
                        (_openBlock(), _createElementBlock("svg", {
                          viewBox: `0 0 ${anchoSvg.value} 240`,
                          class: "grafico-svg",
                          preserveAspectRatio: "xMidYMid meet"
                        }, [
                          _cache[26] || (_cache[26] = _createElementVNode("line", {
                            x1: "42",
                            y1: "12",
                            x2: "42",
                            y2: "190",
                            stroke: "#ccc"
                          }, null, -1)),
                          _createElementVNode("line", {
                            x1: "42",
                            y1: "190",
                            x2: anchoSvg.value - 8,
                            y2: "190",
                            stroke: "#ccc"
                          }, null, 8, _hoisted_69),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ejeTicks.value, (t) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: 't' + t
                            }, [
                              _createElementVNode("line", {
                                x1: "38",
                                y1: yPos(t),
                                x2: "42",
                                y2: yPos(t),
                                stroke: "#bbb"
                              }, null, 8, _hoisted_70),
                              _createElementVNode("line", {
                                x1: "42",
                                y1: yPos(t),
                                x2: anchoSvg.value - 8,
                                y2: yPos(t),
                                stroke: "#f0f0f0"
                              }, null, 8, _hoisted_71),
                              _createElementVNode("text", {
                                x: "34",
                                y: yPos(t) + 3,
                                "text-anchor": "end",
                                class: "eje-label"
                              }, _toDisplayString(t), 9, _hoisted_72)
                            ], 64))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(barras.value, (b, i) => {
                            return (_openBlock(), _createElementBlock("g", {
                              key: b.id
                            }, [
                              _createElementVNode("rect", {
                                x: grupoX(i),
                                y: yPos(b.actual ?? 0),
                                width: anchoBarra,
                                height: 190 - yPos(b.actual ?? 0),
                                fill: "#0e69a0",
                                rx: "2"
                              }, null, 8, _hoisted_73),
                              (b.actual !== null)
                                ? (_openBlock(), _createElementBlock("text", {
                                    key: 0,
                                    x: grupoX(i) + anchoBarra / 2,
                                    y: yPos(b.actual) - 3,
                                    "text-anchor": "middle",
                                    class: "barra-val"
                                  }, _toDisplayString(b.actual.toFixed(2)), 9, _hoisted_74))
                                : _createCommentVNode("", true),
                              _createElementVNode("rect", {
                                x: grupoX(i) + anchoBarra + 4,
                                y: yPos(b.anterior ?? 0),
                                width: anchoBarra,
                                height: 190 - yPos(b.anterior ?? 0),
                                fill: "#eea222",
                                rx: "2"
                              }, null, 8, _hoisted_75),
                              (b.anterior !== null)
                                ? (_openBlock(), _createElementBlock("text", {
                                    key: 1,
                                    x: grupoX(i) + anchoBarra * 1.5 + 4,
                                    y: yPos(b.anterior) - 3,
                                    "text-anchor": "middle",
                                    class: "barra-val"
                                  }, _toDisplayString(b.anterior.toFixed(2)), 9, _hoisted_76))
                                : _createCommentVNode("", true),
                              _createElementVNode("text", {
                                x: grupoX(i) + anchoBarra + 2,
                                y: "204",
                                "text-anchor": "middle",
                                class: "barra-label"
                              }, _toDisplayString(b.ordinal ? fmtOrdinal(b.ordinal) : b.nombre.slice(0, 10)), 9, _hoisted_77)
                            ]))
                          }), 128))
                        ], 8, _hoisted_68))
                      ])),
                  _createElementVNode("p", _hoisted_78, "Barras: calificación (0–" + _toDisplayString(comparacion.value.escala_max) + ") por periodo. Azul = actual, dorado = anterior.", 1)
                ], 512), [
                  [_vShow, vista.value === 'grafico']
                ])
              ], 64))
            : _createCommentVNode("", true),
    _createVNode(MensajeFlotante, {
      visible: msgVisible.value,
      mensaje: msgTexto.value,
      tipo: msgTipo.value,
      onCerrar: _cache[8] || (_cache[8] = ($event: any) => (msgVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"])
  ]))
}
}

})